import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const Hero = ({ onDiscordClick }) => {
  const textLines = [
    "Welcome to",
    "QUANTUM SHOP",
    "Premium Roblox Items"
  ];

  return (
    <section className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Animated background grid */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-purple-950/20 to-black">
        <div className="absolute inset-0" style={{
          backgroundImage: `
            linear-gradient(rgba(147, 51, 234, 0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(147, 51, 234, 0.1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
          animation: 'gridMove 20s linear infinite'
        }} />
      </div>

      {/* Floating orbs */}
      <motion.div
        className="absolute top-20 left-10 w-64 h-64 bg-purple-600/30 rounded-full blur-3xl"
        animate={{
          y: [0, 30, 0],
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <motion.div
        className="absolute bottom-20 right-10 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl"
        animate={{
          y: [0, -40, 0],
          scale: [1, 1.2, 1],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      {/* Main content */}
      <div className="relative z-10 text-center px-4 max-w-6xl mx-auto">
        {/* Masked line reveal */}
        <div className="mb-8 overflow-hidden">
          {textLines.map((line, index) => (
            <motion.div
              key={index}
              initial={{ y: 100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                duration: 0.8,
                delay: index * 0.2,
                ease: [0.6, 0.05, 0.01, 0.9]
              }}
            >
              <h1 className={`${
                index === 1 
                  ? 'text-7xl md:text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-500 via-purple-600 to-purple-700 mb-2'
                  : 'text-2xl md:text-4xl font-light text-gray-400 tracking-wider'
              }`}>
                {line}
              </h1>
            </motion.div>
          ))}
        </div>

        {/* Subtitle with stagger */}
        <motion.p
          className="text-lg md:text-xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          Your trusted source for <span className="text-purple-500 font-semibold">Pet Simulator 99</span>, 
          <span className="text-purple-500 font-semibold"> Adopt Me</span>, and 
          <span className="text-purple-500 font-semibold"> Murder Mystery 2</span> items
        </motion.p>

        {/* Discord CTA Button */}
        <motion.div
          className="flex justify-center"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1 }}
        >
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              onClick={onDiscordClick}
              size="lg"
              className="relative group bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white px-12 py-8 text-xl font-bold rounded-xl shadow-2xl shadow-purple-500/50 overflow-hidden transition-all duration-300"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <span className="relative flex items-center gap-3">
                <Sparkles className="w-6 h-6" />
                Join the Discord Server Here
              </span>
            </Button>
          </motion.div>
        </motion.div>
      </div>

      <style>{`
        @keyframes gridMove {
          0% { transform: translateY(0); }
          100% { transform: translateY(50px); }
        }
      `}</style>
    </section>
  );
};

export default Hero;
